import { Guid } from "@/Common/Models/Guid";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { UserSettings } from "@/Globals/Models/UserSettings";
import { CacheStore } from "@/Globals/Stores/CacheStore";
import { NotesFilterSettings } from "@/Patient/Models/Settings/NotesFilterSettings";
import { SummaryConfigurationSettings } from "@/Patient/Models/Settings/SummaryConfigurationSettings";

class CacheHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Misc.ReloadEmployeesAndService, this.reloadEmployeeAndServices);
        this.RegisterOperation(LocalOperations.Misc.ReloadLookups, this.refreshLookup);
        this.RegisterOperation(LocalOperations.Sites.SetActiveSite, this.setActiveSite);
        this.RegisterOperation(LocalOperations.Misc.UpdateNotesFilterSettings, this.updateNotesFilterSettings);
        this.RegisterOperation(LocalOperations.Misc.UpdateSummaryConfigurationSettings, this.updateSummaryConfigurationSettings);
    }

    public setActiveSite(request: LocalEvent): void {
        const activeSiteId = request.Get<Guid>("ActiveSiteId");

        if (activeSiteId == null) {
            throw new Error("Active Site ID must be provided.");
        }
        cacheStore.GetCurrentEmployee().ActiveSiteId = activeSiteId;
        cacheStore.EmitChangeToListeners();
    }

    public updateNotesFilterSettings(response: LocalEvent): void {
        const notesFilterSettings = response.Get<NotesFilterSettings>("notesFilterSettings") ?? cacheStore.UserSettings?.NotesFilterSettings;

        cacheStore.UserSettings ??= new UserSettings();
        cacheStore.UserSettings.NotesFilterSettings = notesFilterSettings;
    }

    private reloadEmployeeAndServices(response: LocalEvent, store: CacheStore): void {
        store.actions.refreshServicesAndLookups();
    }

    private refreshLookup(response: LocalEvent, store: CacheStore): void {
        store.actions.refreshLookups();
    }

    public updateSummaryConfigurationSettings(response: LocalEvent): void {
        const summaryConfigurationSettings = response.Get<SummaryConfigurationSettings>("summaryConfigurationSettings") ?? cacheStore.UserSettings?.SummaryConfigurationSettings;

        cacheStore.UserSettings.SummaryConfigurationSettings = summaryConfigurationSettings;
        patientStore.EmitChangeToListeners();
    }
}

export { CacheHandler };
